module.exports = __webpack_public_path__ + "img/11.1.f1792bff.jpg";